import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tmp\\claude\\web-main\\src\\views\\agenda\\AgendaRedirect.js");
